<!-- ====================================================== -->
<!-- LOGIN ERROR MODAL -->
<!-- ====================================================== -->

<div
    class="modal fade hide"
    id="loginErrorModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="loginErrorModal"
    aria-hidden="true">

    <div
        class="modal-dialog modal-dialog-centered"
        role="document">

        <div class="modal-content login-error-content">

            <div class="modal-body login-error-body">


                <!-- ================================================== -->
                <!-- ERROR CON URL -->
                <!-- ================================================== -->

                <ng-container *ngIf="hasRedirectUrl; else genericLoginError">


                    <!-- CERRAR -->
                    <button
                        type="button"
                        class="login-access-close"
                        data-dismiss="modal"
                        aria-label="Cerrar">

                        <i class="fi fi-br-x"></i>

                    </button>


                    <!-- ICONO -->
                    <div class="login-access-icon">

                        <i class="fi fi-rr-lock"></i>

                    </div>


                    <!-- TITULO -->
                    <h1 class="login-access-title">

                        No puedes ingresar a esta plataforma

                    </h1>


                    <!-- DESCRIPCION -->
                    <p class="login-access-description">

                        No tienes un convenio asociado a

                        <strong>
                            {{ customerName }}
                        </strong>, por lo que no puedes ingresar a través
                        de esta plataforma.

                    </p>


                    <p class="login-access-description mb-3">

                        Si deseas ingresar, revisa tus convenios
                        o accede a través de:

                    </p>


                    <!-- URL -->
                    <button
                        type="button"
                        class="login-access-url"
                        (click)="redirectToUrl()">

                        <i class="fi fi-rr-globe"></i>

                        <span>
                            {{ displayUrl }}
                        </span>

                    </button>


                    <!-- ACCIONES -->
                    <div class="login-access-actions">


                        <button
                            type="button"
                            class="btn login-access-btn-secondary"
                            data-dismiss="modal">

                            Cerrar

                        </button>


                        <button
                            type="button"
                            class="btn login-access-btn-primary"
                            (click)="redirectToUrl()">

                            Ir al sitio

                        </button>


                    </div>


                </ng-container>


                <!-- ================================================== -->
                <!-- ERROR GENERICO -->
                <!-- ================================================== -->

                <ng-template #genericLoginError>

                    <div
                        class="
                            container-fluid
                            m-0
                            p-0
                            text-center
                        ">


                        <i
                            class="material-icons"
                            style="
                                color:var(--am-primary,#171994);
                                font-size:48px;
                                margin:10px auto;
                                display:block;
                            ">

                            mood_bad

                        </i>


                        <div class="m-0 px-1 px-sm-5">

                            <h1
                                style="
                                    font-family:Mulish,sans-serif;
                                    font-style:normal;
                                    font-weight:600;
                                    font-size:20px;
                                    line-height:1.4;
                                    margin-bottom:8px;
                                    word-wrap:break-word;
                                ">

                                Lo sentimos, la información que
                                ingresaste es incorrecta.

                            </h1>


                            <br>


                            <h1
                                style="
                                    font-family:Mulish,sans-serif;
                                    font-style:normal;
                                    font-weight:600;
                                    font-size:18px;
                                    line-height:1.2;
                                    word-wrap:break-word;
                                    color:#555;
                                ">

                                Por favor, vuelve a intentar.

                            </h1>

                        </div>


                        <button
                            class="btn"
                            type="button"
                            data-dismiss="modal"
                            aria-label="Close">

                            Volver a intentar

                        </button>


                    </div>

                </ng-template>


            </div>

        </div>

    </div>

</div>